import React from 'react'
import styled from 'styled-components'
import { Subhead } from 'src/Styles/text-styles'
import { SpeedResultState } from 'src/Common/SpeedResultState'
import { DarkButton } from 'src/Component/ThemedButton'
import FastExpectationDetail from 'src/Result/ExpectationDetail/FastExpectationDetails'
import SlowExpectationDetail from 'src/Result/ExpectationDetail/SlowExpectationDetails'
import UnstableExpectationDetail from 'src/Result/ExpectationDetail/UnstableExpectationDetails'
import { useHistory } from 'react-router-dom'
import { theme } from 'src/Styles/theme'
import { Route } from 'src/Common/Route'
import useMediaQuery from 'src/Utils/useMediaQuery'
import { analytics } from 'src/Analytics'
import { CheckAgainTappedEvent } from 'src/Analytics/SpeedTestEvents'
import { localize } from 'src/lib/localize'

const Container = styled.div`
  flex: 1;
  justify-content: flex-start;
  min-width: fit-content;
  @media (min-width: 768px) {
    margin-left: 40px;
  }
`

const InnerContainer = styled.div`
  @media (max-width: 768px) {
    border-radius: 14px;
    box-shadow: 0px 1px 1px ${theme.colors.boxShadowColor};
    background-color: ${theme.colors.white};
    elevation: 1;
    padding: 12px;
    margin-left: 16px;
    margin-right: 16px;
    margin-top: 16px;
  }
`

const BtnContainer = styled.div`
  width: 50%;
  display: flex;
  justify-content: flex-start;
  padding-top: 14px;
  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    align-items: center;
    pointer-events: none;
  }
`

const TryAgainText = localize('BUTTON')('Check Again')

interface ExpectationDetailProps {
  resultState: SpeedResultState
  showTryAgainButton?: boolean
}

const ExpectationDetail = ({
  resultState,
  showTryAgainButton = true,
}: ExpectationDetailProps) => {
  const history = useHistory()
  const isMobileView = useMediaQuery(['(max-width: 768px)'], [true], false)

  const getBulletComponent = () => {
    switch (resultState) {
      case SpeedResultState.FAST:
        return <FastExpectationDetail />
      case SpeedResultState.SLOW:
        return <SlowExpectationDetail />
      case SpeedResultState.UNSTABLE:
        return <UnstableExpectationDetail />

      default:
        return <FastExpectationDetail />
    }
  }
  return (
    <Container>
      <InnerContainer>{getBulletComponent()}</InnerContainer>

      {showTryAgainButton && (
        <BtnContainer>
          <DarkButton
            style={{
              width: isMobileView ? '70%' : '100%',
              pointerEvents: 'auto',
            }}
            onPress={() => {
              history.push(Route.HOME, { restart: true })
              analytics.trackEvent(CheckAgainTappedEvent())
            }}
            title={TryAgainText}
          />
        </BtnContainer>
      )}
    </Container>
  )
}

export default ExpectationDetail
